export default "__VITE_ASSET__CAoKxDAR__"